<template>
  <div id="top-container">
    <!-- <b-navbar variant="light" type="light" class="cnc-nav-bar"> -->
    <!-- <b-navbar-brand href="#">
        <img
          alt="logo"
          src="./assets/logo.svg"
          style="min-width: 100px"
          class="d-inline-block align-top"
        />
      </b-navbar-brand>
      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-text>Apply for CNC</b-nav-text>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar> -->
    <!-- <b-navbar variant="light" type="light" style="visibility: hidden">
      <b-navbar-brand href="#">
        <img
          alt="logo"
          src="./assets/logo.svg"
          style="min-width: 100px"
          class="d-inline-block align-top"
        />
      </b-navbar-brand>
      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-text>Apply for CNC</b-nav-text>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar> -->
    <div id="tetra-logo">
      <img src="./assets/logo.png" style="max-width: 300px;" />
    </div>
    <application style="margin-bottom: 80px;" id="app" />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {
    application,
  },
  data() {
    return {
      showCardEntry: true,
      showSuccess: false,
      showDismissibleAlert: false,
      alertMessage: "",
      successMessage: "",
      showSuccessAlert: false,
    };
  },
  methods: {
    onCompletePurchase() {
      this.showCardEntry = false;
      this.showSuccess = true;
    },
  },
};

import application from "./components/application.vue";
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#top-container {
  background: linear-gradient(#ffffff44, #ffffff44),
    url("assets/bg-org.jpg") center;
  /* background-position: center; */
  /* background-repeat: no-repeat; */
  background-size: cover;
  height: 100vh;
  width: 100vw;
}
#tetra-logo {
  padding-top: 10px;
}
#tetra-logo img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.cnc-nav-bar {
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  position: fixed !important;
  z-index: 10;
  width: 100%;
  margin-top: -5px;
}
</style>
